import { Component, Inject } from '@angular/core';
import {
    CmpsPopulationCompareGroupData,
    CmpsPopulationCompareResult,
} from '@cmps/ng-kit';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

@Component({
    selector: 'cmps-period-compare-dialog',
    templateUrl: './population-compare-dialog.component.html',
})
export class CmpsPopulationCompareDialogComponent {
    cmpsGroupData: CmpsPopulationCompareGroupData[];
    constructor(
        /** @private */ public readonly _dialogRef: CmpsDialogRef<
            CmpsPopulationCompareDialogComponent,
            CmpsPopulationCompareResult
        >,
        /** @private */ @Inject(CMPS_DIALOG_DATA)
        readonly _dialogData: CmpsPopulationCompareGroupData[],
    ) {
        this.cmpsGroupData = _dialogData;
    }

    /** @private */
    _onCompareAction(data: CmpsPopulationCompareResult): void {
        this._dialogRef.close(data);
    }
}
